import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { OneWayInService } from 'src/api/v2';

import {
  ONE_WAY_IN_FORM_IN_RESPONSE_MAIL,
  ONE_WAY_IN_GROUPED_FORM_ENROLLMENT,
  ONE_WAY_IN_GROUPED_FORM_WITHOUT_SAVE,
} from 'src/constants/hook-keys';
import { useAuth } from 'src/features/authorization';

const useOneWayInReview = (formId: string | undefined = '') => {
  const [oneWayInService] = useState(new OneWayInService());

  const { checkAccess } = useAuth();
  const { read } = checkAccess('OneWayIn');

  const oneWayInReviewGroupedFormQuery = useQuery({
    queryKey: [ONE_WAY_IN_GROUPED_FORM_WITHOUT_SAVE, formId],
    queryFn: () => oneWayInService.getInquiry(formId),
    enabled: !!formId && read,
    retry: false,
    staleTime: 1000 * 60 * 15, // 15 min refetching on mount
    refetchOnMount: true,
    keepPreviousData: false,
  });

  const oneWayInGroupedFormEnrollment = useQuery({
    queryKey: [ONE_WAY_IN_GROUPED_FORM_ENROLLMENT, formId],
    queryFn: () => oneWayInService.getEnrollments(formId),
    enabled: !!formId && read,
    retry: false,
    staleTime: 1000 * 60 * 15, // 15 min refetching on mount
    refetchOnMount: true,
  });

  const onewWayInOpportunityFormINResponseMailQuery = useQuery({
    queryKey: [ONE_WAY_IN_FORM_IN_RESPONSE_MAIL, formId],
    queryFn: () => {
      return oneWayInService.getInquiryINResponse(formId);
    },
    enabled: !!formId && read,
    retry: false,
    refetchOnMount: false,
    keepPreviousData: false,
  });

  return {
    oneWayInReviewGroupedFormQuery,
    oneWayInGroupedFormEnrollment,
    onewWayInOpportunityFormINResponseMailQuery,
  };
};

export default useOneWayInReview;
